import { render } from "./BsSimpleModal.vue?vue&type=template&id=470f8db6"
import script from "./BsSimpleModal.vue?vue&type=script&lang=js"
export * from "./BsSimpleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__